import { render, staticRenderFns } from "./HolidayPeriodEditPage.vue?vue&type=template&id=e4bdb7b8&scoped=true&"
import script from "./HolidayPeriodEditPage.vue?vue&type=script&lang=ts&"
export * from "./HolidayPeriodEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./HolidayPeriodEditPage.vue?vue&type=style&index=0&id=e4bdb7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bdb7b8",
  null
  
)

export default component.exports